import * as React from 'react'
import Routes from 'utils/routes'
import { useRouter } from 'next/router'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import Collection, { CollectionItem } from 'components/atomic/molecules/collection'
import { I18n, useTranslation } from 'components/hooks/use-translation'
import Button from 'components/atomic/atoms/button'
import { Path } from 'types/types'

const RelatedPaths = (props: Path) => {
    const { t }: I18n = useTranslation()
    const router = useRouter()

    const items = React.useMemo(() => {
        return props.related_paths.map((p) => ({
            item: p,
            type: 'path',
        }))
    }, [props.related_paths]) as CollectionItem[]

    return (
        <Collection
            key="related-paths"
            title={t('path:otherPaths')}
            items={items}
            endButton={
                <Button color="primary" onClick={() => router.push(Routes.Paths)} endIcon={<ChevronRightIcon />}>
                    {t('path:buttons.otherPaths')}
                </Button>
            }
        />
    )
}

export default RelatedPaths
